<template>
	<ProjectMenuTabsExplanation @dismiss="onDismiss" v-if="!useDismissedSpaceTabExplanation">
		<h5>
			Spaces define who can edit and share assets. Use-only access to features is managed separately.
			<a class="learn" target="_blank" href="https://docs.ply.io/manage-and-collaborate/understand-spaces"> Learn more </a>
		</h5>
	</ProjectMenuTabsExplanation>
</template>

<script>
import { mapGettersShorthand, mapActionsShorthand } from '@/store/utils/mappers';
import { useDismissedSpaceTabExplanation } from '@/store/modules/appLayout/getters.js';
import { setDismissedSpaceTabExplanation } from '@/store/modules/appLayout/actions.js';
import ProjectMenuTabsExplanation from '@/components/ProjectMenu/ProjectMenuTabsExplanation.vue';
export default {
	name: 'SpaceTabExplanation',
	components: { ProjectMenuTabsExplanation },
	computed: {
		...mapGettersShorthand({ useDismissedSpaceTabExplanation }),
	},
	methods: {
		...mapActionsShorthand({ setDismissedSpaceTabExplanation }),
		onDismiss() {
			this.setDismissedSpaceTabExplanation({ dismissed: true });
		},
	},
};
</script>

<style scoped lang="scss">
.learn {
	color: #6f6bdc;
}
</style>
